//import 'babel-polyfill';
import "core-js/stable";
import gj from 'gijgo/js/gijgo.min.js';

var supervisedEntitiesData = null;

$(document).ready(() => {
    let apiUrl = window.conf.apiUrl;
    let countryUrl = window.conf.countryUrl;
    let apiKey = window.conf.apiKey;
    let hierarchyUrl = window.conf.hierarchyUrl;
    let language = window.conf.language;
    let translatedLabels = window.conf.labels;
    let languages = { fi: 0, sv: 1, en: 2 };
    let countryLanguages = { fi: 'fi', sv: 'se', en: 'en' }
    let exportFileName = window.conf.exportFileName ? window.conf.exportFileName : "export";
    let isSupervisedPage = window.conf.isSupervisedPage;

    let searchHidden = false;

    let currentPage = 0;
    let itemsPerPage = 30;
    let pageCount = 0;

    var checkAllId = -1;

    let errorDiv = $('#SE_error');

    let countries = [];
    let countriesLoaded = false;

    // Load country names
    $.ajax({
        method: "GET",
        url: countryUrl,
        headers: {
            "Ocp-Apim-Subscription-Key": apiKey,
            "Accept": "application/json"
        },
        traditional: true
    }).done((data,) => {
        countries = propsToLowerCase(data);
        countriesLoaded = true;
    }).fail(() => console.error("Could not load country names"))

    $('#tree-search-form').on('submit', function (event) {
        event.preventDefault();
        $('#tree-search-button').trigger('click');
    })

    $('#tree-export-button').on('click', e => {
        if (supervisedEntitiesData === null)
            return;

        var BOM = "\uFEFF";
        let csv = BOM + createCsv(supervisedEntitiesData);

        let blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        csv = "data:text/csv;charset=utf-8," + csv;

        let hash = hashCode(csv);
        let fileName = `${exportFileName}_${hash}.csv`;

        // For IE
        if (window.navigator.msSaveOrOpenBlob) {
            if (!window.navigator.msSaveOrOpenBlob(blob, fileName))
                console.log(`Loading file ${fileName} with IE failure`);
        }
        // For proper browsers
        else {
            let encodedUri = encodeURI(csv);

            // hashtags must be encoded, else the links href breaks there
            // encodeURIComponent() would be an easy solution, but it encodes too much and the links don't work anymore
            encodedUri = encodedUri.replace(/#/g, '%23');
            const link = document.createElement('a');
            link.href = encodedUri;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        //console.log(csv);
    })

    var hashCode = function (s) {
        var h = 0, l = s.length, i = 0;
        if (l > 0)
            while (i < l)
                h = (h << 5) - h + s.charCodeAt(i++) | 0;
        return h;
    };

    let treeNode = $('#tree');
    let tree = $(treeNode).tree({
        primaryKey: "groupNumber",
        uiLibrary: "bootstrap",
        dataSource: {
            url: hierarchyUrl,
            error: (error) => {
                console.log(error);
            }
        },
        checkboxes: true,
        textField: "groupName",
        childrenField: "children"
    })

    // Add "all"-option to the tree
    tree.on('dataBound', function () {
        tree.addNode({ groupName: translatedLabels.checkall, groupNumber: -1 });
    })

    let checkAllEventDone = false;

    tree.on('checkboxChange', function (e, node, record, state) {
        if (record.groupNumber === checkAllId) {
            // checkAllEventDone-variable stops this running again from the tree.uncheckAll() / tree.uncheckAll()
            if (!checkAllEventDone) {
                if (state === 'checked') {
                    checkAllEventDone = true;
                    tree.checkAll();
                }
                else {
                    checkAllEventDone = true;
                    tree.uncheckAll();
                }
            } else {
                checkAllEventDone = false;
            }
        }
    })

    $('#tree-search-button').on('click', () => {
        let intervalId = setInterval(function () {
            $('.supervised-spinner').show();

            if (!countriesLoaded) {
                console.log("Countries not loaded yet");
                return;
            }

            let text = $('#tree-search-input').val();
            let checkedIds = tree.getCheckedNodes();
            
            SearchItems(checkedIds, text, checkAllId);
            clearInterval(intervalId);
        }, 100);
    })
    // 1. Rakennetaan map: groupNumber -> displayStyle
    let groupDisplayMap = {};

    // 1. Hae hierarchyData ja rakenna map
    $.ajax({
        url: hierarchyUrl,
        method: "GET",
        headers: { "Ocp-Apim-Subscription-Key": apiKey }
    }).done(hierarchyData => {
        buildGroupDisplayMap(hierarchyData);
        console.log("groupDisplayMap built:", groupDisplayMap);

        // 2. Hae items data-API:sta
        $.ajax({
            url: apiUrl,
            method: "GET",
            headers: { "Ocp-Apim-Subscription-Key": apiKey }
        }).done(itemsData => {
            console.log("itemsData:", itemsData);

            //itemsData.forEach(item => {
            //    const div = createContactInformation(item);
            //    if (div) {
            //        $('#container').append(div);
            //    }
            //});
        }).fail(() => console.error("Could not load items data"));

    }).fail(() => console.error("Could not load hierarchy data"));

    function buildGroupDisplayMap(groups) {
        if (!groups) return;

        const arr = Array.isArray(groups) ? groups : [groups];

        arr.forEach(g => {

            const groupNumber = Number(g.groupNumber);
            if (!isNaN(groupNumber)) {
                groupDisplayMap[groupNumber] = Number(g.displayStyle) || 0;
            }

            if (g.children) {
                buildGroupDisplayMap(g.children);
            }
        });
    }

    //function getDisplayStyleForItem(item) {
    //    if (!item || !item.groups || item.groups.length === 0) return 0;

    //    const groupNumber = Number(item.groups[0].groupnumber);
    //    if (isNaN(groupNumber)) return 0;

    //    return groupDisplayMap[groupNumber] || 0;
    //}
    function getDisplayStyleForItem(item) {
        if (!item || !item.groups || item.groups.length === 0) return 0;

        let minDisplayStyle = null;

        item.groups.forEach(g => {
            const groupNumber = Number(g.groupnumber);
            if (isNaN(groupNumber)) return;

            const style = Number(groupDisplayMap[groupNumber]);
            if (isNaN(style) || style <= 0) return;

            if (minDisplayStyle === null || style < minDisplayStyle) {
                minDisplayStyle = style;
            }
        });

        return minDisplayStyle;
    }

    function hasDisplayElement(displayStyle, element) {
        return (displayStyle & element) === element;
    }

    const DisplayElement = {
        Telephone: 1,
        Telefax: 2,
        WWWAddress: 4,
        PostalAddress: 8,
        HeadOfficeAddress: 16,
        OfficeAddress: 32,
        VisitingAddress: 64,
        ConsumerComplaintsAddress: 128
    };

    function renderAddressBlock(div, title, addresses) {
        if (!addresses || !addresses.length) return;

        div.append($('<h4>').text(title));

        addresses.forEach(addr => {
            div.append(
                $('<p>')
                    .append(addr.address ? addr.address : "")
                    .append(addr.address || addr.address ? '<br />' : "")
                    .append(addr.zipcode ? addr.zipcode+" " : "")
                    .append(addr.city ? addr.city : "")
                    .append(addr.city || addr.zipcode ? '<br />' : "")
                    .append(addr.country ? addr.country : "")
            );
        });
    }

    function renderContactRow(div, label, value) {
        if (!value) return;

        div.append(
            $('<div>')
                .addClass('contact-row')
                .text(`${label}: ${value}`)
        );
    }

    var createContactInformation = (item) => {
        if (!item.telefax && !item.telephone && !item.address && !item.address2 && !item.zipcode && !item.city && !item.homestate && !item.wwwaddress) {
            return
        }
        const displayStyle = getDisplayStyleForItem(item);
        console.log(displayStyle)        
        let div = $('<div />').addClass("SE_contact_information").addClass("SE_item");
        $('<h4 />')
            .text(translatedLabels.contactinformation)
            .appendTo(div);
        let div2 = $('<div />')
            .addClass("SE_item_info")
            .addClass("contactinformation")
            //.append(`${(item.telephone ? translatedLabels.telephone + ": " + item.telephone : "") + (item.telefax ? ", " + translatedLabels.telefax + ": " + item.telefax : "")}`)
            //.append(item.telephone || item.telefax ? "<br />" : "")

        //if (isSupervisedPage || item.groups.findIndex(x => x.groupnumber === 2200) < 0) {
        //    div2.append(item.address ? item.address + '<br />' : "")
        //        .append(item.address2 ? item.address2 + '<br />' : "")
        //        .append(`${item.zipcode ? item.zipcode + " " : ""}${item.city ? item.city : ""}`)
        //        .append(item.zipcode || item.city ? '<br />' : "")
        //        .append(item.homestate ? item.homestate + '<br />' : '')
        //        .append('<div style="margin-top: 10px;"/>')
        //        .append(item.businessaddress ? item.businessaddress + '<br />' : '')
        //        .append(`${item.businesszipcode ? item.businesszipcode + " " : ""}${item.businesscity ? item.businesscity : ""}`)
        //};
        //if ((displayStyle & DisplayElement.Telephone) && item.telephone) {
        //    $('<p/>').text("Telephone: " + item.telephone).appendTo(div);
        //}



        if (hasDisplayElement(displayStyle, DisplayElement.WWWAddress)) {
            div2.append(() => {
                if (item.wwwaddress) {
                    let address;
                    if (item.wwwaddress.startsWith('http://'))
                        address = item.wwwaddress;
                    else if (item.wwwaddress.startsWith('https://'))
                        address = item.wwwaddress;
                    else
                        address = 'http://' + item.wwwaddress;

                    return $('<a />').attr("href", address).text(item.wwwaddress).add('<br/>');
                }
            });
        }
        if (hasDisplayElement(displayStyle, DisplayElement.Telephone)) {
            renderContactRow(div2, translatedLabels.telephone, item.telephone);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.Telefax)) {
            renderContactRow(div2, translatedLabels.telefax, item.telefax);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.PostalAddress)) {
            renderAddressBlock(div2, translatedLabels.postaladdress, item.postaladdress);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.HeadOfficeAddress)) {
            renderAddressBlock(div2, translatedLabels.headofficeaddress, item.headofficeaddress);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.OfficeAddress)) {
            renderAddressBlock(div2, translatedLabels.officeaddress, item.officeaddress);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.VisitingAddress)) {
            renderAddressBlock(div2, translatedLabels.visitingaddress, item.visitingaddress);
        }
        if (hasDisplayElement(displayStyle, DisplayElement.ConsumerComplaintsAddress)) {
            if (item.consumercomplaintsaddress) {

                if (div2.children().length) {
                    div2.append("<br/>");
                }
                div2.append(
                    $('<h4>').text(translatedLabels.consumercomplaintsaddress || "Consumer Complaints Address")
                ).append()
                    .append(item.consumercomplaintsaddress);
            }
        }
        div2.appendTo(div);

        if (!div.find('.contactinformation').children().length)
            return;
        return div;
    }

    var createPersonsInCharge = (item) => {
        return _createItemWithList(item, "personsInCharge", x => {
            return `${x.title}: ${x.name}`;
        }, '<br />')
    }

    var createSupervisors = (item) => {
        return _createItemWithList(item, "supervisorsInFSA", x => {
            return `${x.name}, ${translatedLabels.telephone}: ${x.telephonenumber}`;
        }, '<br />');
    }

    var createAuthorisations = (item) => {
        return _createItemWithList(item, "authorisationsAndOtherOperationGrounds", x => x.authorisationname || x, '<br />', list => sortAlphabetically(list, item => item.authorisationname || item));
        //return _createItemWithList(item, "authorisationsAndOtherOperationGrounds", x => x);
    }

    var createAuxiliaryName = (item) => {
        return _createItemWithSingleLine(item, "auxiliaryName", x => x.auxiliaryname);
    }

    var createBusinessCode = (item) => {
        return _createItemWithSingleLine(item, "businessIdentityCode", x => x.businessidentitycode);
    }

    var createHomeState = (item) => {
        return _createItemWithSingleLine(item, "homeState", x => x.homestate);
    }

   //added 24.02.2020 - FIVAYP-82
    var createServicesDescription = (item) => {
        return _createItemWithSingleLine(item, "servicesdescription", x => x.servicesdescription);

    }

    var createProvidedServices = (item) => {
        return _createItemWithList(item, "providedServices", x => x.servicename || x, '<div style="margin-top: 8px;"/>', list => sortAlphabetically(list, item => item.servicename || item));
        //return _createItemWithList(item, "providedServices", x => x);
    }

    //var createFunds = (item) => {
    //    return _createItemWithList(item, "funds", x => $('<div/>').addClass('fund clearfix').append($('<span/>').text(x.fundname)).append($('<span/>').text(x.fundtype)), '<br />');
    //}

    var createFunds = (item) => {
        // Check if the company belongs to group 2200
        let isGroup2200 = item.groups.some(group => group.groupnumber === 2200);

        // If it belongs to group 2200, change the header to 'sidonnaisasiamiehet'
        let headerText = isGroup2200 ? translatedLabels.tiedagents : null;

        return _createItemWithList(item, "funds", x => $('<div/>').addClass('fund clearfix').append($('<span/>').text(x.fundname)).append($('<span/>').text(x.fundtype)), '<br />', undefined, headerText);
    };

    var createPrincipalOfAnAgent = (item) => {
        return _createItemWithList(item, "principalOfAnAgent", x => x, '<br />');
    }

    var createDateOfRegistration = (item) => {
        return _createItemWithSingleLine(item, 'dateOfRegistration', x => new Date(x.dateofregistration).toLocaleDateString());
    }

    var createServicesInCountry = (item) => {
        if (!item["servicesincountry"] || !item["servicesincountry"].length) {
            return;
        }

        let _countries = item["servicesincountry"].reduce((accumulator, currentValue) => {
            if (accumulator.indexOf(currentValue.countrycode) < 0)
                accumulator.push(currentValue.countrycode)

            return accumulator;
        }, []);

        let output = _countries.reduce((accumulator, currentValue) => {
            accumulator[currentValue] = item["servicesincountry"].filter(x => x.countrycode === currentValue).map(x => x.servicename);
            return accumulator;
        }, {});

        let sorted = [];
        Object.keys(output).forEach(function (key) {
            var country = countries.find(x => x.countrycode === key);
            let _lang = countryLanguages[language];
            var lang = country ? country["countryname" + _lang] : key;
            sorted.push({ lang: lang, services: output[key] });
        });

        sorted.sort((a, b) => a.lang.localeCompare(b.lang));

        if (Object.getOwnPropertyNames(output).length == 0)
            return;

        let element = $('<div/>').addClass('SE_providedservices SE_item');
        $('<h4/>').text(translatedLabels.servicesincountry).appendTo(element);
        let info = $('<div/>').addClass("SE_item_info").appendTo(element);

        sorted.forEach(item => {
            let outerDiv = $('<div/>').addClass('country').appendTo(info);

            let services = $('<div/>').addClass('services').hide();
            item.services.forEach(x => {
                services.append(x).append($('<br/>'));
            })

            let chevron = $('<i/>').addClass('chevron-down rotate')
                .on('click', function (e) {
                    services.slideToggle();
                    $(this).toggleClass('down');
                });

            $('<span/>').text(item.lang)
                .on('click', function (e) {
                    services.slideToggle();
                    chevron.toggleClass('down');
                })
                .appendTo(outerDiv);

            chevron.appendTo(outerDiv);
            services.appendTo(outerDiv);
        });

        return element;
    }

    var createTiedAgent = (x) => {
        var providedServices = [];
        if (x['placefinancialinstrumentstoclients'])
            providedServices.push(translatedLabels.tiedagent_placefinancialinstrumentstoclients);
        if (x['promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients'])
            providedServices.push(translatedLabels.tiedagent_promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients);
        if (x['provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients'])
            providedServices.push(translatedLabels.tiedagent_provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients);
        if (x['receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments'])
            providedServices.push(translatedLabels.tiedagent_receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments);

        var tiedAgent = $('<div /> ')
            .addClass('SE_tied_agent');

        var tiedAgentName = $('<p />')
            .addClass('SE_tied_agent_name')
            .text(x['tiedagentname'])
            .append($('<i />').addClass('fa').addClass('fa-chevron-down').addClass('rotate'))
            .on('click', e => {
                $(e.currentTarget).parent('.SE_tied_agent').toggleClass('active');
                $(e.currentTarget).find('i.rotate').toggleClass('down');
                tiedAgentInfo.slideToggle();
            })
            .appendTo(tiedAgent);

        var providedServicesList = $('<ul />').addClass('SE_provided_services');

        $.each(providedServices, (index, service) => {
            providedServicesList
                .append($('<li />')
                    .text(service))
        })

        var tiedAgentInfo = $('<div />')
            .addClass('SE_tied_agent_info')
            .append($('<div />')
                .addClass('row')
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(translatedLabels.tiedagent_tiedagentidentitycode))
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(x['tiedagentidentitycode'])))
            .append($('<div />')
                .addClass('row')
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(translatedLabels.tiedagent_streetaddress))
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(x['streetaddress'])))
            .append($('<div />')
                .addClass('row')
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(translatedLabels.tiedagent_zipcode))
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(x['zipcode'])))
            .append($('<div />')
                .addClass('row')
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(translatedLabels.tiedagent_homestate))
                .append($('<div />')
                    .addClass('col-xs-12').addClass('col-sm-6')
                    .text(x['homestate'])))
            .append($('<div />')
                .addClass('row')
                .append($('<div />')
                    .addClass('col-xs-12')
                    .text(translatedLabels.tiedagent_providedservices)
                    .append(providedServicesList)))
            .appendTo(tiedAgent);

        return tiedAgent;
    }

    var createTiedAgents = (item) => {
        return _createItemWithList(item, "tiedAgents", (x) => createTiedAgent(x), '<br />');
    }

    //var _createItemWithList = (item, name, createListItem, spacer = '', sortFunction = undefined) => {
    //    name = name.toLowerCase();

    //    if (!item[name] || !item[name].length) {
    //        //console.log(name, "is", item[name]);
    //        return;
    //    }
    //    let div = $('<div />').addClass(`SE_${name}`).addClass("SE_item");
    //    let heading = $('<h4 />');

    //    const differentFundGroups = [4889, 5001, 5003, 5006, 5007, 5011, 5012];
    //    if (name === 'funds' && item.groups.some(group => differentFundGroups.includes(group.groupnumber))) {
    //        heading.text(translatedLabels[name + '2'] || name)
    //    } else {
    //        heading.text(translatedLabels[name] || name)
    //    }
    //    heading.appendTo(div);
    //    let list = $('<div />')
    //        .addClass("SE_item_info")
    //        .appendTo(div);

    //    let items = [];
    //    if (sortFunction)
    //        items = sortFunction(item[name]);
    //    else
    //        items = item[name];

    //    items.forEach(x => {
    //        let newItem = createListItem(x);
    //        list.append(newItem);
    //        if (spacer)
    //            list.append(spacer);
    //    })
    //    return div;
    //}

    var _createItemWithList = (item, name, createListItem, spacer = ' ', sortFunction = undefined, customHeaderText = null) => {
        name = name.toLowerCase();

        if (!item[name] || !item[name].length) {
            return;
        }

        let div = $('<div />').addClass(`SE_${name}`).addClass("SE_item");
        let heading = $('<h4 />');
        // Laajennettu lista, joka sisältää alkuperäiset sekä uudet ryhmät
        const differentFundGroups = [4889, 5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5021];
        // Use custom header text if provided, otherwise fallback to the default translation
        if (name === 'funds' && item.groups.some(group => differentFundGroups.includes(group.groupnumber))) {
            heading.text(customHeaderText || translatedLabels[name + '2'] || name);
        } else {
            heading.text(customHeaderText || translatedLabels[name] || name);
        }

        heading.appendTo(div);

        let list = $('<div />')
            .addClass("SE_item_info")
            .appendTo(div);

        let items = [];
        if (sortFunction)
            items = sortFunction(item[name]);
        else
            items = item[name];

        if (!Array.isArray(items)) {
            items = normalizeItems(items);
        }
        items.forEach(x => {
            let newItem = createListItem(x);
            list.append(newItem);
            if (spacer)
                list.append(spacer);
        });
        return div;
    };

    var _createItemWithSingleLine = (item, name, createItem) => {
        name = name.toLowerCase();
        if (!item[name]) {
            //console.log(name, "is", item[name]);
            return;
        }
        let div = $('<div />').addClass(`SE_${name}`).addClass("SE_item");
        $('<h4 />')
            .text(translatedLabels[name] || name)
            .appendTo(div);
        $('<div />')
            .addClass("SE_item_info")
            .append(createItem(item))
            .appendTo(div);
        return div;
    }

    var createBasicItem = (item) => {
        let li = $('<li />').addClass("SE_list_item").addClass("list-group-item");

        let chevron = $('<i />')
            .addClass('chevron-down')
            .addClass('rotate');

        let name = $('<p />')
            .text(item.companyname)
            .addClass("SE_company_name")
            .attr('tabindex', 0)
            .attr('aria-expanded', false)
            .on('click', (e) => toggleFunction(e))
            .on('keypress', function (e) {
                if (e.which === 13 || e.which === 32) {
                    e.preventDefault();
                    toggleFunction(e);
                    
                }
            });

        var toggleFunction = (e) => {
            if ($(e.currentTarget).nextAll('div.SE_content_div').children().length > 0) {
                contentDiv.slideToggle();
                chevron.toggleClass('down');
                if ($(e.currentTarget).attr('aria-expanded') == 'false') {
                    $(e.currentTarget).attr('aria-expanded', true);
                } else {
                    $(e.currentTarget).attr('aria-expanded', false);
                }

            }
        }
        li.append(name);
        item.groups.forEach(group => {
            li.append(group.groupname).append($('<br/>'));
        })

        var contentDiv = $('<div />').addClass("SE_content_div").appendTo(li);

        contentDiv.append(createAuxiliaryName(item));
        contentDiv.append(createContactInformation(item));
        contentDiv.append(createPersonsInCharge(item));
        contentDiv.append(createSupervisors(item));
        contentDiv.append(createAuthorisations(item));
        contentDiv.append(createBusinessCode(item));
        contentDiv.append(createHomeState(item));
        contentDiv.append(createProvidedServices(item));
        contentDiv.append(createFunds(item));
        contentDiv.append(createPrincipalOfAnAgent(item));
        contentDiv.append(createTiedAgents(item));
        contentDiv.append(createServicesInCountry(item));
        contentDiv.append(createDateOfRegistration(item));
        contentDiv.append(createServicesDescription(item));

        if (contentDiv.children().length > 0) {
            name.append(chevron);
        } else {
            name.addClass('empty');
        }

        return li;
    }

    var createItemsList = (totalCount, items, div) => {
        $('<h3 />')
            .attr("id", "supervised-results")
            .text(translatedLabels.searchresults + " (" + totalCount + " " + translatedLabels.pieces + ")")
            .appendTo(div);

        let ul = $('<ul />')
            .attr("aria-labelledby", "supervised-results")
            .addClass("SE_list")
            .addClass("list-group")
            .appendTo(div);
        items.forEach(item => {
            ul.append(createBasicItem(item));
        })

        if (items.length > 0) {
            $('#tree-export-button').show();
            errorDiv.hide();
            $('#supervised_items').find('p.SE_company_name').first().focus()
        } else {
            $('#tree-export-button').hide();
            errorDiv
                .show()
                .text(translatedLabels.noresults);
        }
    }

    var search = (searchParams) => {
        return $.when($.ajax({
            method: "GET",
            url: apiUrl,
            headers: {
                "Ocp-Apim-Subscription-Key": apiKey,
                "Accept": "application/json"
            },
            data: searchParams,
            traditional: true
        }))
    }

    var SearchItems = (ids, name, checkAllId) => {
        //console.log("Fetching by: " + name + ", ids:" + ids);

        $('.supervised-spinner').show();

        var data = {
            Lang: languages[language],
            //Page: 1,
            //PageSize: 50
        };

        if (ids && ids.length)
            data['Groups'] = ids.filter(x => x !== checkAllId);
        if (name)
            data['CompanyName'] = name;

        search(data)
            .then(data => {
                if (!Array.isArray(data)) {
                    throw new Error("Data must be an array");
                }
                data = data.map(x => propsToLowerCase(x));
                data = sortAlphabetically(data, item => item.companyname);
                //data = data.sort(function (a, b) {
                //    var x = a.companyname.toLowerCase();
                //    var y = b.companyname.toLowerCase();
                //    if (x < y) { return -1; }
                //    if (x > y) { return 1; }
                //    return 0;
                //});
                return data;
            })
            .then(data => {
                supervisedEntitiesData = data;
                createPagination(data, $('#supervised_items_pagination'));
                updateItemsList(data, 1);
                $('.supervised-spinner').hide();
            })
            .catch(error => {
                $('.supervised-spinner').hide();
                errorDiv.show().text(translatedLabels.errorloadingdata);
                console.error(error);
            })
    }

    function sortAlphabetically(list, propToSortBy) {
        return list.sort((a, b) => {
            var x = propToSortBy(a).toLowerCase();
            var y = propToSortBy(b).toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        })
    }

    var updateItemsList = (newItems, page) => {
        currentPage = page;
        let startIndex = (page - 1) * itemsPerPage;
        let items = newItems.slice(startIndex, startIndex + itemsPerPage);

        let div = $('#supervised_items');
        div.empty();
        createItemsList(newItems.length, items, div);
    }

    var createPagination = (items, target) => {
        pageCount = Math.ceil(items.length / itemsPerPage);

        target.twbsPagination('destroy');

        if (pageCount === 0)
            return;

        target.twbsPagination({
            totalPages: pageCount,
            visiblePages: Math.floor(($('#supervised_items_nav').width() - 30) / 40) - 2,
            first: '<i class="first-page"/>',
            prev: '<i class="prev-page"/>',
            next: '<i class="next-page"/>',
            last: '<i class="last-page"/>',
            hideOnlyOnePage: true,
            onPageClick: (e, page) => {
                e.preventDefault();
                navigateToPage(page);
            }
        })
    }

    var navigateToPage = (pageNumber) => {
        updateItemsList(supervisedEntitiesData, pageNumber);
    }

    var createCsv = (items) => {
        let rows = [];

        let headerRow = [
            translatedLabels['companyname'],
            translatedLabels['businessidentitycode'],
            translatedLabels['contactinformation'],
            translatedLabels['wwwaddress'],
            translatedLabels['supervisorsinfsa'],
            translatedLabels['authorisationsandotheroperationgrounds'],
        ];

        if (isSupervisedPage) {
            headerRow.push(
                translatedLabels['providedservices']
                //    translatedLabels['tiedagent_tiedagentname'],
                //    translatedLabels['tiedagent_placefinancialinstrumentstoclients'],
                //    translatedLabels['tiedagent_promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients'],
                //    translatedLabels['tiedagent_provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients'],
                //    translatedLabels['tiedagent_receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments']
            )
        }
        rows.push(headerRow);

        items.forEach(item => {
            //let row = [];
            let repeatablePart = [];

            repeatablePart.push(item['companyname']);
            repeatablePart.push(item['businessidentitycode']);

            let contactInformation = [];
            if (propExists(item, 'telephone'))
                contactInformation.push(translatedLabels.telephone + ": " + item['telephone']);
            if (propExists(item, 'telefax'))
                contactInformation.push(translatedLabels.telefax + ": " + item['telefax']);
            if (propExists(item, 'address'))
                contactInformation.push(item['address']);
            if (propExists(item, 'address2'))
                contactInformation.push(item['address2']);
            if (propExists(item, 'zipcode'))
                contactInformation.push(item['zipcode']);
            if (propExists(item, 'city'))
                contactInformation.push(item['city']);
            if (propExists(item, 'homestate'))
                contactInformation.push(item['homestate']);
            if (propExists(item, 'locationofheadoffice'))
                contactInformation.push(item['locationofheadoffice']);
            if (propExists(item, 'consumercomplaintsaddress'))
                contactInformation.push(item['consumercomplaintsaddress']);

            repeatablePart.push(contactInformation.join(', '));
            repeatablePart.push(item['wwwaddress']);
            repeatablePart.push(item['supervisorsinfsa'].map(s => `${s.name}${s.role}, ${translatedLabels.telephone}: ${s.telephonenumber}`).join(', '));
            repeatablePart.push(item['authorisationsandotheroperationgrounds'].map(x => x.authorisationname).join(', '));

            if (isSupervisedPage) {
                repeatablePart.push(item['providedservices'].map(x => x.servicename).join(', '));

                //if (item['tiedagents'] && item['tiedagents'].length) {
                //    item['tiedagents'].forEach(t => {
                //        let row = [].concat(repeatablePart);
                //        row.push(t['tiedagentname']);
                //        row.push(t['placefinancialinstrumentstoclients'] ? "x" : "")
                //        row.push(t['promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients'] ? "x" : "")
                //        row.push(t['provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients'] ? "x" : "")
                //        row.push(t['receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments'] ? "x" : "")
                //        rows.push(row);
                //    })
                //} else {
                //    // Add the tied-agent columns
                //    repeatablePart = repeatablePart.concat(['', '', '', '', '']);
                //    rows.push(repeatablePart);
                //}
            }
            //else {
            //    rows.push(repeatablePart);
            //}
            rows.push(repeatablePart);
        })

        return rows.map(row => {
            return row.map(x => x ? x.toString().replace(/(\r\n|\n|\r)/gm, '') : '').join(';');
        }).join('\r\n');
    }

    var propExists = (item, prop) => {
        return item[prop] && item[prop] !== "";
    }

    var propsToLowerCase = (original) => {
        if (Array.isArray(original))
            return original.map(x => propsToLowerCase(x));
        if (typeof original === 'string' || typeof original === 'number')
            return original;
        if (original === null)
            return null;
        return Object.keys(original).reduce((newObj, key) => {
            let val = original[key];
            let newVal = (typeof val === 'object') ? propsToLowerCase(val) : val;
            newObj[key.toLowerCase()] = newVal;
            return newObj;
        }, {});
    }
    
    function normalizeItems(items) {
        if (Array.isArray(items)) {
            return items;
        }
        if (typeof items === "string") {
            return items
                .split(",")
                .map(x => x.trim())
                .filter(Boolean);
        }
        return [];
    }
})